<div class="bloc-content-body">
  @if (form) {
    <form class="form w-100" [formGroup]="form" (ngSubmit)="submit()">
      <div class="bloc-input">
        <label for="code">Merci de saisir le code de confirmation reçu par email:<sup>*</sup></label>
        <input
          type="text"
          id="code"
          name="code"
          formControlName="code"
          placeholder="Le code de confirmation"
          required
          />
        @if (formSubmitted && getError('code')) {
          <small class="error-message">
            {{ getError('code') }}
          </small>
        }
      </div>
      <div class="row w-100 pt-3 text-center">
        <div class="col-12 w-100 cta_container">
          <button type="submit" class="cta_btn level_2 column">Valider<span></span></button>
        </div>
      </div>
    </form>
  }
</div>
